import { render, staticRenderFns } from "./CardModalDetailsType.vue?vue&type=template&id=386d2c23&scoped=true"
import script from "./CardModalDetailsType.vue?vue&type=script&lang=js"
export * from "./CardModalDetailsType.vue?vue&type=script&lang=js"
import style0 from "./CardModalDetailsType.vue?vue&type=style&index=0&id=386d2c23&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386d2c23",
  null
  
)

export default component.exports